import { Button, Card, Form, Select, Space, TimePicker } from 'antd'
import { Option } from 'antd/es/mentions';
import React, { useEffect, useState } from 'react'
import PageHeading from '../../../../components/common/PageHeading'
import { Input } from 'antd';




const ShowingSettings = (props) => {
    const [showIt, setShowIt] = useState(false);
    const [showList, setShowList] = useState(false);

    const [selectedOption, setSelectedOption] = useState('Central Time (US & Canada');
    const eligibleCharge = [

        { value: 'Central Time (US & Canada', label: 'Central Time (US & Canada' },
        { value: 'Arizona', label: 'Arizona' },
        { value: 'Eastern Time', label: 'Eastern Time' },
        { value: 'Hawaii', label: 'Hawaii' },
    ];


    const handleChange = (value) => {
        setSelectedOption(value);
    };
    const cancelButton = () => {
        setShowIt(false);


    }
    const { Search } = Input;

    const onFinish = (values) => {
        setSelectedOption(values.selectedOption);
        setShowIt(false);
    };
    const editButton = () => {
        setShowIt(true)
    }

    return (
        <Card
            size="large"
            title={props.title}
            extra={<a onClick={editButton}>{!showIt && "Edit"}</a>}
            style={{
                width: '100%'
            }}>

            {!showIt &&
                <p style={{ textAlign: 'center' }} >
                    {selectedOption}
                </p>
            }

            <Form onFinish={onFinish}>
                {showIt &&
                    <div style={{ display: 'flex', flexDirection: 'column', margin: '10px' }}>
                        <Form.Item
                            label="Time Zone"
                            name="selectedOption"
                        >
                            <Select
                                showSearch
                                options={eligibleCharge}
                                onChange={handleChange}
                                value={selectedOption}
                                placeholder="Search by Property or Proprty Group" />
                        </Form.Item>
                    </div>

                }

                {
                    showIt && <div style={{ display: 'flex' }}>

                        <Form.Item>
                            <button className='blue' style={{
                                margin: '0 2px', borderRadius: '10%', padding: '8px 12px', cursor: 'pointer', backgroundColor: 'blue',
                                color: 'white'
                            }} >Save
                            </button>
                        </Form.Item>
                        <Form.Item>
                            <button style={{
                                margin: '0 2px', borderRadius: '10%',
                                padding: '8px 12px', cursor: 'pointer', border: '0.1px solid gray', backgroundColor: 'white',
                                color: 'black'
                            }}
                                onClick={cancelButton}>Cancel</button>
                        </Form.Item>

                    </div>
                }
            </Form>
        </Card>
    )
}

export default ShowingSettings;
